export interface RoadMarkingRenderConfig {
  /** Two standard three-metre traffic lanes must fit before a centre line appears. */
  readonly minimumMarkedCarriagewayWidthM: number;
  /** A wider carriageway may expose additional same-direction lane dividers. */
  readonly minimumMultiLaneCarriagewayWidthM: number;
  readonly targetLaneWidthM: number;
  readonly maximumLanesPerDirection: number;
  readonly lineWidthM: number;
  readonly dashLengthM: number;
  readonly dashGapM: number;
  readonly maximumCurveSegmentLengthM: number;
  readonly junctionTrimM: number;
  readonly crossingClearanceM: number;
  readonly surfaceLiftM: number;
  readonly solidLineWidthM: number;
  /** Centre-to-centre gap between the two lines of KET marking 1.3. */
  readonly doubleCentreLineSeparationM: number;
  readonly edgeLineInsetM: number;
  readonly cycleLaneInsetM: number;
  readonly parkingLaneInsetM: number;
  readonly stopLineWidthM: number;
  readonly stopLineApproachOffsetM: number;
  readonly turnArrowLengthM: number;
  readonly turnArrowWidthM: number;
  readonly turnArrowSetbackM: number;
}

/**
 * Visual dimensions follow the current Lithuanian horizontal-marking rules at
 * the low-detail scale of the game. Placement remains deliberately
 * conservative: only source-backed paved carriageways wide enough for two
 * standard lanes receive inferred longitudinal paint.
 */
export const ROAD_MARKING_RENDER_CONFIG:
  Readonly<RoadMarkingRenderConfig> = Object.freeze({
    minimumMarkedCarriagewayWidthM: 6,
    minimumMultiLaneCarriagewayWidthM: 11.5,
    targetLaneWidthM: 3,
    maximumLanesPerDirection: 4,
    lineWidthM: 0.12,
    dashLengthM: 3,
    dashGapM: 3,
    maximumCurveSegmentLengthM: 2.5,
    junctionTrimM: 3.4,
    crossingClearanceM: 0.7,
    surfaceLiftM: 0.018,
    solidLineWidthM: 0.12,
    doubleCentreLineSeparationM: 0.34,
    edgeLineInsetM: 0.2,
    cycleLaneInsetM: 1.25,
    parkingLaneInsetM: 2.05,
    stopLineWidthM: 0.42,
    stopLineApproachOffsetM: 1.4,
    turnArrowLengthM: 3.2,
    turnArrowWidthM: 0.18,
    turnArrowSetbackM: 8.5,
  });
